import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MapModeService, MapTapMode } from '../../services/map-mode.service';
import { IconComponent } from '../../../shared/components/icon/icon.component';
import { TippyDirective } from '../../../shared/directives/tippy.directive';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

/**
 * Segmented toggle shown in the toolbar while on the map page: controls
 * whether tapping a building creates a new interaction or opens its history.
 */
@Component({
  selector: 'app-map-mode-toggle',
  standalone: true,
  imports: [IconComponent, TippyDirective, TranslatePipe],
  templateUrl: './map-mode-toggle.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './map-mode-toggle.component.css',
})
export class MapModeToggleComponent {
  protected readonly mapModeService = inject(MapModeService);

  protected setMode(mode: MapTapMode): void {
    this.mapModeService.setMode(mode);
  }
}
